module.exports = __webpack_public_path__ + "static/media/bottom_logo.c147e26c.png";